

export const content = {
  app: {
    description: 'Un portal de información sobre películas y series',
    title: 'Dollygrip',
  },
  castAndCrew: {
    subTitles: {
      CREATOR: 'Creado por',
      DIRECTOR: 'Dirigido por',
      EXECUTIVE_PRODUCER: 'Producción ejecutiva de',
      GUEST_STAR: 'Con la participación especial de',
      NOVEL: 'Novela',
      PRODUCER: 'Producido por',
      SCREENPLAY: 'Guion',
      STAR: 'Protagonizada por',
      WRITER: 'Escrito por',
    },
  },
  categories: {
    continueWatching: 'Seguir viendo',
    favorites: 'Favoritos',
    recentlyWatched: 'Visto recientemente',
    shortcuts: 'Accesos directos',
    watchlist: 'Lista de seguimiento',
  },
  cookieConsent: {
    acceptButton: 'Acepto',
    content: "**This application uses cookies**\n\nWe use essential cookies to make the app work. We also use additional cookies to analyse site traffic to improve your experience.",
    customiseButton: 'Personalizar',
  },
  header: {
    closeSearchAriaLabel: 'Cerrar la barra de búsqueda',
    mainMenuAriaLabel: 'Abrir el menú de géneros para descubrir',
    openSearchAriaLabel: 'Abrir la barra de búsqueda',
    searchAriaLabel: 'Buscar películas, series, reparto y equipo técnico',
    searchPlaceholder: 'Buscar...',
  },
  homepage: {
    sections: {
      popularAnimatedMovies: 'Películas animadas populares',
      popularAnimatedTv: 'Series animadas populares',
      popularMovies: 'Películas populares',
      popularNature: 'Documentales de naturaleza populares',
      popularTv: 'Series populares',
      topRatedAnimatedMovies: 'Películas animadas mejor valoradas',
      topRatedAnimatedTv: 'Series animadas mejor valoradas',
      topRatedDocs: 'Documentales mejor valorados',
      topRatedMovies: 'Películas mejor valoradas',
      topRatedTv: 'Series mejor valoradas',
      trending: 'Tendencias',
    },
  },
  pages: {
    discover: 'Descubrir',
  },
  reviewsBadge: {
    ariaLabel: 'Mostrar reseñas de usuarios',
    title: 'Reseñas',
  },
  ribbons: {
    movieAndTv: {
      CANCELED: 'Cancelado',
      ENDED: 'Finalizado',
      IN_PRODUCTION: 'En prod',
      PLANNED: 'Planificado',
      POST_PRODUCTION: 'Postprod',
      RETURNING_SERIES: 'En regreso',
      RUMORED: 'Rumor',
    },
    season: {
      airingNow: 'Ahora',
      airs: 'Emis',
    },
  },
  screenTypes: {
    MOVIE: 'Película',
    TV: 'Serie de TV',
  },
  theMovieDb: {
    disclaimer:
      'Esta aplicación utiliza TMDB y las APIs de TMDB, pero no está avalada, certificada ni aprobada de ninguna manera por TMDB.',
  },
  watchlist: {
    UPCOMING: {
      fallbackContent: "##### Keep on top of upcoming movies and tv shows by adding them to your watchlist\n\nJust select the <AlarmOff /> icon next to the movie or TV show you'd like to keep track of. On tiles, you can add to your watchlist by selecting the <MoreVert /> icon in the top right corner.",
    },
    airDates: {
      CANCELED: {
        fallback: 'Fecha de última emisión desconocida',
        withDate: 'Última emisión',
      },
      IN_PRODUCTION: 'Planeado para',
      PILOT: {
        fallback: 'Fecha del próximo episodio desconocida',
        withDate: 'Próximo episodio',
      },
      PLANNED: 'Planeado para',
      RETURNING_SERIES: {
        fallback: 'Fecha del próximo episodio desconocida',
        withDate: 'Próximo episodio',
      },
    },
    categories: {
      CANCELED: 'Cancelada',
      COMPLETED: 'Estrenada',
      IN_PRODUCTION: 'En rodaje',
      PLANNED: 'Planificada',
      UPCOMING: 'Próximamente',
    },
    movieReleaseDateFallback: 'Sin fecha de estreno',
    releaseDates: {
      CANCELED: 'Estaba planeado para',
      IN_PRODUCTION: 'Planeado para',
      PLANNED: 'Planeado para',
      POST_PRODUCTION: 'Estreno previsto',
      RELEASED: 'Estrenado',
      RUMORED: 'Planeado para',
      present: 'Presente',
    },
    tablist: {
      ariaLabel: 'Categorías de la lista de seguimiento',
    },
    tvAirDateFallback: 'Sin fecha de emisión',
  },
  watchlistBadge: {
    addAriaLabel: 'Agregar a la lista',
    removeAriaLabel: 'Quitar de la lista',
  },
} as const;
